.uic-tag {
    display: inline-flex;
    align-items: center;

    box-sizing: border-box;
    height: var(--uic-dim-height);
    padding: 0 8px;
    margin: 8px 4px;

    color: var(--uic-color-blue4);
    background: var(--uic-color-blue6a20);
    border: 1px solid transparent;

    font-size: var(--uic-font-size-normal);
    line-height: var(--uic-line-height-normal);
    font-weight: var(--uic-font-weight-bold);

    cursor: default;

    &:focus {
        outline: 2px solid var(--uic-color-blue2);
        outline-offset: -2px;
        color: var(--uic-color-blue4);
    }

    &:hover {
        outline: 1px solid var(--uic-color-blue2);
        outline-offset: -1px;
        color: var(--uic-color-blue3);

        .uic-tag__clear {
            color: inherit;
        }
    }

    &--disabled {
        border: 1px solid var(--uic-color-grey2a25);
        color: var(--uic-color-grey5);
        background: var(--uic-color-white);
        font-weight: var(--uic-font-weight-normal);
        pointer-events: none;

        .uic-tag__clear {
            color: inherit;
        }
    }

    &__clear {
        width: var(--uic-icon-dimensions-default);
        height: var(--uic-icon-dimensions-default);
        color: var(--uic-color-grey3);
        margin-left: 8px;
        margin-right: 4px;
        cursor: pointer;
    }
}
